import React, { useState } from 'react';
import api from '../api';
import './Login.css'; // Utilisation du CSS de Login
import GoogleLogin from './GoogleLogin';

const Signup = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState({ text: '', type: '' });
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [acceptedTerms, setAcceptedTerms] = useState(false);

    const handleSignup = async (e) => {
        e.preventDefault();
        
        if (!acceptedTerms) {
            setMessage({ text: 'Please accept the Terms of Service and Privacy Policy to continue', type: 'error' });
            return;
        }
        
        setIsButtonLoading(true);
        try {
            const response = await api.post('/signup', { email });
            setMessage({ 
                text: response.data.msg || 'Activation email sent to your email', 
                type: response.data.status || 'success' 
            });
        } catch (error) {
            console.error('Signup error:', error);
            if (error.response && error.response.data && error.response.data.msg) {
                setMessage({ text: error.response.data.msg, type: 'error' });
            } else {
                setMessage({ text: 'Failed to send activation email', type: 'error' });
            }
        } finally {
            setIsButtonLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <img src="logo_dark.png" alt="Logo" className="login-logo" />
                <h2>Create an account</h2>
                <p>Enter your email to create an account</p>
                
                {message.text && (
                    <div className={message.type === 'error' ? 'error-message' : 'success-message'}>
                        {message.text}
                    </div>
                )}

                <form onSubmit={handleSignup}>
                    <div className="input-group">
                        <div className="icon-container">
                            <span className="material-symbols-outlined login-icon">mail</span>
                        </div>
                        <input
                            type="email"
                            placeholder="your@example.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="checkbox-container">
                        <input 
                            type="checkbox" 
                            checked={acceptedTerms}
                            onChange={(e) => setAcceptedTerms(e.target.checked)}
                            required 
                        />
                        <label>
                            I agree to the <a href="/terms" target="_blank">Terms of Service</a> and <a href="/privacy" target="_blank">Privacy Policy</a>
                        </label>
                    </div>

                    <div style={{ marginTop: '30px' }}>
                        <button className="button-plain" type="submit" disabled={isButtonLoading}>
                            <span className="material-symbols-outlined icon">email</span>
                            {isButtonLoading ? 'Requesting...' : 'Request activation email'}
                        </button>
                    </div>
                </form>

                <p className="login-toggle-text">
                    Already have an account? <strong onClick={() => window.location.href = '/login'}>Login</strong>
                </p>

                <div className="login-separator">
                    <span>or</span>
                </div>

                <GoogleLogin />
                
                <p className="google-disclaimer">
                    By continuing with Google, you agree to our <a href="/terms" target="_blank">Terms of Service</a> and <a href="/privacy" target="_blank">Privacy Policy</a>
                </p>
            </div>
        </div>
    );
};

export default Signup;
